import { StoreState } from '@/redux/types';
import { getCore } from './getCore';

export const getDigitalColors = (state: StoreState) => getCore(state).digitalColors;
